import './TypeEvents.css';
import typeOff from './../../images/type-off.svg';
import typeOn from './../../images/type-on.svg';
import { useState } from 'react';
const TypeEvents = ({
    source,
    setCurrentPage,
    categories,
    setEventSubCategory,
    setNewEventCategory,
    translations,
    setEventSubCategoryId,
    setNewRecommendCategory,
    isFullScreenMode,
}) => {
    const [activeCategory, setActiveCategory] = useState(null);

    const handleCategoryClick = (event, categoryId) => {
        event.stopPropagation();
        setActiveCategory(activeCategory === categoryId ? null : categoryId);
    };

    const handleSubCategoryClick = (subCategoryName) => {
        if (source === 'MainPage') {
            const subCategoryNames = subCategoryName.name;
            const subCategoryId = subCategoryName.id;
            setEventSubCategory(subCategoryNames);
            setEventSubCategoryId(subCategoryId);
            setCurrentPage('MapPage');
        } else if (source === 'NewEvents') {
            setNewEventCategory(subCategoryName);
            setCurrentPage('AddEventPage');
        } else {
            setNewRecommendCategory(subCategoryName);
            setCurrentPage('AddRecommendPage');
        }
    };

    return (
        <div className='type__events'>
            <div
                className={
                    isFullScreenMode
                        ? 'type__events_container_full'
                        : 'type__events_container'
                }
            >
                <div
                    className={
                        isFullScreenMode
                            ? 'type__events_title_full'
                            : 'type__events_title'
                    }
                >
                    <h1>{translations.eventType}</h1>
                </div>
                <div className='type__events_wrapper'>
                    <ul className='type__events_list'>
                        {categories.map((category) => (
                            <li key={category.id} className='type__events_item'>
                                <div
                                    className='type__events_items'
                                    onClick={(event) =>
                                        handleCategoryClick(event, category.id)
                                    }
                                >
                                    <p>{category.name}</p>
                                    <img
                                        src={
                                            activeCategory === category.id
                                                ? typeOn
                                                : typeOff
                                        }
                                    />
                                </div>
                                <ul
                                    className={`type__events_list_add ${
                                        activeCategory === category.id
                                            ? 'active'
                                            : ''
                                    }`}
                                >
                                    {category.subCategories.map(
                                        (subCategory) => (
                                            <li
                                                key={subCategory.id}
                                                className='type__events_item_add'
                                                onClick={() =>
                                                    handleSubCategoryClick(
                                                        subCategory
                                                    )
                                                }
                                            >
                                                {subCategory.name}
                                            </li>
                                        )
                                    )}
                                </ul>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default TypeEvents;
